import * as React from 'react';
import { SVGProps } from 'react';
export const SvgExpandDown = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={10}
        height={6}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 1L5 5L9 1"
            stroke={props.color || '#8E94A9'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
